export default {"src":"/_next/static/media/S.9735b23d.svg","height":18,"width":18};